import { render } from "./RadiologyRequestDetails.vue?vue&type=template&id=49e47504"
import script from "./RadiologyRequestDetails.vue?vue&type=script&lang=js"
export * from "./RadiologyRequestDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__